package com.tovtalk.utils.language

import com.tovtalk.utils.strings.setAppLanguageForStrings
import kotlinx.browser.document

actual fun syncAppLanguageToPlatform(languageCode: String) {
    setAppLanguageForStrings(languageCode)
    val dir = if (languageCode == "he") "rtl" else "ltr"
    val lang = if (languageCode == "he") "he" else "en"
    document.documentElement?.setAttribute("dir", dir)
    document.documentElement?.setAttribute("lang", lang)
    document.getElementById("root")?.setAttribute("dir", dir)
    document.getElementById("root")?.setAttribute("lang", lang)
}
